// extracted by mini-css-extract-plugin
export default {"tipsContainer":"TipCard_tipsContainer__B+Qs9","tipsText":"TipCard_tipsText__RulWV"};